import type { JSX } from 'react';

interface CargillLeafSpinnerProps {
  isDark?: boolean;
  size?: number | string;
}


const CargillLeafSpinner = ({
  isDark = false,
  size = 64
}: CargillLeafSpinnerProps): JSX.Element => (
  <svg
    className="cargill-spinner"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 66 66"
    width={size}
    height={size}
    data-testid="cargill-leaf-spinner"
    style={{
      animation: 'cargillSpinnerRotate 0.75s linear infinite',
      transformOrigin: '50% 50%',
      display: 'block'
    }}
  >
    <style>
      {`@keyframes cargillSpinnerRotate {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }`}
    </style>

    <path
      data-testid="cargill-leaf-spinner-path"
      d="M33.0341 23.6516C36.4551 21.6559 38.7273 
      17.9836 38.7273 13.8C38.7273 9.61633 36.4551 
      5.94403 33.0341 3.94837C33.013 3.93607 32.987 
      3.93607 32.9659 3.94837C29.5449 5.94403 27.2728 
      9.61633 27.2728 13.8C27.2728 17.9836 29.5449 21.6559 
      32.9659 23.6516C32.987 23.6639 33.013 23.6639 
      33.0341 23.6516ZM34.5458 26.2429C33.5906 26.8001 
      32.4094 26.8001 31.4543 26.2429C27.157 23.736 24.2728 
      19.102 24.2728 13.8C24.2728 8.4979 27.157 3.86393 
      31.4543 1.35706C32.4094 0.799843 33.5906 0.799843 
      34.5458 1.35706C38.8431 3.86393 41.7273 8.4979 41.7273 
      13.8C41.7273 19.102 38.8431 23.736 34.5458 26.2429ZM33.0341 
      62.0514C36.4551 60.0558 38.7273 56.3835 38.7273 52.1998C38.7273 
      48.0162 36.4551 44.3439 33.0341 42.3482C33.013 42.3359 32.987 
      42.3359 32.9659 42.3482C29.5449 44.3439 27.2728 48.0162 27.2728 
      52.1998C27.2728 56.3835 29.5449 60.0558 32.9659 62.0514C32.987 
      62.0637 33.013 62.0637 33.0341 62.0514ZM34.5458 64.6427C33.5906 
      65.2 32.4094 65.2 31.4543 64.6427C27.157 62.1359 24.2728 57.5019 
      24.2728 52.1998C24.2728 46.8978 27.157 42.2638 31.4543 39.7569C32.4094 
      39.1997 33.5906 39.1997 34.5458 39.7569C38.8431 42.2638 41.7273 46.8978 41.7273 
      52.1998C41.7273 57.5019 38.8431 62.1359 34.5458 64.6427ZM52.2 27.2728C48.0164 
      27.2728 44.3441 29.5449 42.3485 32.9659C42.3362 32.987 42.3362 33.013 42.3485 
      33.0341C44.3441 36.4551 48.0164 38.7272 52.2 38.7272C56.3837 38.7272 60.056 
      36.4551 62.0516 33.0341C62.0639 33.013 62.0639 32.987 62.0516 32.9659C60.056 
      29.5449 56.3837 27.2728 52.2 27.2728ZM39.7572 31.4542C39.1999 32.4094 39.1999 
      33.5906 39.7571 34.5458C42.264 38.843 46.898 41.7272 52.2 41.7272C57.5021 41.7272 
      62.1361 38.843 64.6429 34.5458C65.2002 33.5906 65.2002 32.4094 64.6429 31.4542C62.1361 
      27.157 57.5021 24.2728 52.2 24.2728C46.898 24.2728 42.264 27.157 39.7572 31.4542ZM3.94858 
      33.0341C5.94425 36.4551 9.61654 38.7272 13.8002 38.7272C17.9838 38.7272 21.6561 36.4551 23.6518 
      33.0341C23.6641 33.013 23.6641 32.987 23.6518 32.9659C21.6561 29.5449 17.9838 27.2728 13.8002 
      27.2728C9.61655 27.2728 5.94425 29.5449 3.94858 32.9659C3.93629 32.987 3.93629 33.013 3.94858 
      33.0341ZM1.35728 34.5458C0.800055 33.5906 0.800056 32.4094 1.35728 31.4542C3.86415 27.157 8.49812 
      24.2728 13.8002 24.2728C19.1022 24.2728 23.7362 27.157 26.2431 31.4542C26.8003 32.4094 26.8003 
      33.5906 26.2431 34.5458C23.7362 38.843 19.1022 41.7272 13.8002 41.7272C8.49812 41.7272 3.86415 
      38.843 1.35728 34.5458Z"
      fill={isDark ? '#ffffff' : '#00843d'}
    />
  </svg>
);

export default CargillLeafSpinner;